var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class PanasonicProjectorTelnet {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = '1.00.01';
        this.power = false;
        this.serialNumber = 'SW12345678';
        this.timeouts = new Timeouts();
        this.videoMute = false;
        this.videoSelection = 'HD1';
        this.volume = 32;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'firmwareVersion',
                regExp: /00QVX:SVRS0/i,
                callback: (match) => {
                    this.socket.send(`SVRS0=${this.firmwareVersion}`);
                },
            },
            {
                name: 'serialNumber',
                regExp: /00QSN/i,
                callback: (match) => {
                    this.socket.send(this.serialNumber);
                },
            },
            {
                name: 'powerQuery',
                regExp: /00QPW/i,
                callback: (match) => {
                    this.socket.send(this.power ? '00001' : '00000');
                },
            },
            {
                name: 'powerSet',
                regExp: /00P(ON|OF)/i,
                callback: (match) => {
                    this.power = match[1] === 'ON';
                    this.socket.send(`00P${match[1]}`);
                },
            },
            {
                name: 'videoMuteQuery',
                regExp: /00QSH/i,
                callback: (match) => {
                    this.socket.send(`00${this.videoMute ? '001' : '000'}`);
                },
            },
            {
                name: 'videoMuteSet',
                regExp: /00OSH:(\d+)/i,
                callback: (match) => {
                    this.videoMute = match[1] === '1';
                    this.socket.send(`00OSH:${this.videoMute ? '001' : '000'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /00QIN/i,
                callback: (match) => {
                    this.socket.send(`00${this.videoSelection}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /00IIS:(.+)/i,
                callback: (match) => {
                    this.videoSelection = match[1];
                    this.socket.send(`00IIS:${match[1]}`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /00QAV/i,
                callback: (match) => {
                    this.socket.send(this.volume.toString().padStart(3, '0'));
                },
            },
            {
                name: 'volumeSet',
                regExp: /00AVL:(\d+)/i,
                callback: (match) => {
                    this.volume = parseInt(match[1], 10);
                    this.socket.send(`00AVL:${match[1]}`);
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /00QMT/i,
                callback: (match) => {
                    this.socket.send(`00${this.volumeMute ? '001' : '000'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /00AMT:(\d+)/i,
                callback: (match) => {
                    this.volumeMute = match[1] === '1' ? true : false;
                    this.socket.send(`00AMT:${match[1]}`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`ERR1`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code;
            if (this.videoSelection === code)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : 'HD1';
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`NTCONTROL 1 04563b31\r`);
        });
    }
}
PanasonicProjectorTelnet.emulatorType = 'socketEmulator';
PanasonicProjectorTelnet.key = '-LWVuHiNZ3VqgYQi8LZ3';
